import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`There are a lot of movie night chat room, but none of them supports m3u8! Let me fix that...`}</p>
    <h1>{`Intros`}</h1>
    <p>{`Why? A lot of great free resource is using `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`m3u8`}</code>{` for example `}<a parentName="p" {...{
        "href": "https://github.com/topics/m3u8-playlist"
      }}>{`here`}</a>{` and under Shelter In Place orders, keeping social distance and watching these along with friends remotely is highly demanded!`}</p>
    <h1>{`Scope`}</h1>
    <p>{`Users are mostly my UIowa Alumni friends (no more than 8 concurrent users). Scale is not issue at all even if we host on one single old machine. Heroku is free!`}</p>
    <h1>{`Quick Hack`}</h1>
    <p>{`So my target is to finish it asap.`}</p>
    <p>{`After 30min search, I found `}<a parentName="p" {...{
        "href": "https://github.com/kyle8998/Vynchronize"
      }}>{`Vynchronize`}</a>{` comes to my sight... Yeah, it's old js app likely 2008ish which means almost no common js framework and tooling. But you know, hacker doesn't care about that.`}</p>
    <p>{`If we have a player that can play the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`m3u8`}</code>{` then we just need a bit adaptation for the player. Oh, luckily we just found one: `}<a parentName="p" {...{
        "href": "https://dplayer.js.org/guide.html"
      }}>{`DPlayer`}</a>{`!`}</p>
    <p>{`Html5 player in this app is very similar to DPlayer interface wise. So for quick hack, I changed the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`media`}</code>{` which is original html5 video object to dplayer object. The only difference of both interfaces are loading new video `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`switchVideo()`}</code>{` and `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`seek(time)`}</code>{`. This way, we keep the minimum code changes.`}</p>
    <p>{`After 1 hr's reading and writing, changes are done and movie is synchronized! Then just 10 min to deploy it as a Heroku app. I'm totally satisfied with the time spent on this today.`}</p>
    <p>{`Here's my mod `}<a parentName="p" {...{
        "href": "https://github.com/daizeng1984/Vynchronize"
      }}>{`code`}</a>{`, welcome to deploy it for your friends! If you do, don't forget to star it as well!`}</p>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "600px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/04a75e6e5e974487fa695c5e493d7c22/78958/synchronize-m3u8.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAABYlAAAWJQFJUiTwAAABo0lEQVQ4y6VQTUsCURR9fuHWhb+mQEYEZ1FoiwRdZP2I+hG2aNEi281egqQJ+rAvaK1SURSSzjjZFEGljZM6M57emxhJgmjqwuFw7zv3vHsvaUgyrms1NJoymooM5a5FuQVJVijfQW4qYBrGMs0lyrcNyc6Zhul7/YGN914fZOPsBbygYXJdx0S+g/vnNnRdR0frQuvqeKM8jvEa0zAjB+T8XsfywRNWTl6xetqBPjBgmSYMg8L8HQaGYaNPe4ki1aE2rvCi1tF+lNHrveMzhnAbXboZ2dndw9nFJW5qdbTUR2h0jaFlwaQ/u4FFe0RxG2SzWIREj66qD/bD0P1goygUCiCCIGBLFHF4eITj4xPsl0ool8uoVquuUKlUsJbPg8xlsyCEIBgMwuv1wufz2bkbOD1xngfJZufthJm5NXLg9I4Z+v3+Pxs6E/JfDf+y6rcJ43GQ+YUFOwkEAvaDx+MZ3fI3YFrWyzympqdB0un0v28YCoUQDoeRTCZBcrllRKNRpFIpWpjBLOVEIgGO48DR+o+gmlgshkwmg0gkgsXFJXwAVRmzjRDroWAAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Vynchronize with m3u8",
            "title": "Vynchronize with m3u8",
            "src": "/static/04a75e6e5e974487fa695c5e493d7c22/0a47e/synchronize-m3u8.png",
            "srcSet": ["/static/04a75e6e5e974487fa695c5e493d7c22/8a4e8/synchronize-m3u8.png 150w", "/static/04a75e6e5e974487fa695c5e493d7c22/5a46d/synchronize-m3u8.png 300w", "/static/04a75e6e5e974487fa695c5e493d7c22/0a47e/synchronize-m3u8.png 600w", "/static/04a75e6e5e974487fa695c5e493d7c22/1cfc2/synchronize-m3u8.png 900w", "/static/04a75e6e5e974487fa695c5e493d7c22/c1b63/synchronize-m3u8.png 1200w", "/static/04a75e6e5e974487fa695c5e493d7c22/78958/synchronize-m3u8.png 1320w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Vynchronize with m3u8`}</figcaption>{`
  `}</figure>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      